"use client"

import SideBar from './sidebar/index'

export default function Sidebar() {
  return <SideBar />
}